'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { EntityTypes } from 'AdsUI/lib/Constants';
import { dollars } from 'AdsUI/lib/Calculations'; // Adwords can return -- when there isn't a CPC value for a given entity

const ADWORDS_NO_CPC_STRING = '--';

const MaxCPC = ({
  entityType,
  currencySymbol,
  value
}) => {
  if (entityType !== EntityTypes.KEYWORD && entityType !== EntityTypes.ADGROUP) {
    return null;
  }

  const formattedMaxCpcValue = value === ADWORDS_NO_CPC_STRING ? value : dollars(Number(value), currencySymbol);
  return /*#__PURE__*/_jsx("div", {
    className: "max-cpc-cell",
    children: /*#__PURE__*/_jsx("div", {
      className: "display-inline-block",
      children: formattedMaxCpcValue
    })
  });
};

export default MaxCPC;